// Others
import axiosClient from './axiosClient';
import { IFormNoteSchedule, INoteSchedule, IParamNoteSchedule } from '~/utils/interface/schedule';
import { urlApiNotes } from '~/utils/constants/apis';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IFormNote, INote, IQueryGetListNote, IQueryUpdateNote } from '~/utils/interface/note';

const notesApi = {
  createNoteSchedule(body: IFormNoteSchedule) {
    const url = urlApiNotes.createNoteSchedule;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  getNoteScheduleList(params: IParamNoteSchedule) {
    const url = urlApiNotes.getNoteScheduleList;
    return axiosClient.get<IBaseResponse<IListDataResponse<INoteSchedule[]>>>(url, { params });
  },

  getListNote(params: IQueryGetListNote) {
    const url = urlApiNotes.getListNote;
    return axiosClient.get<IBaseResponse<IListDataResponse<INote[]>>>(url, { params });
  },

  createNote(body: IFormNote) {
    const url = urlApiNotes.createNote;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  updateNote({ noteId, body }: IQueryUpdateNote) {
    const url = urlApiNotes.updateNote(noteId);
    return axiosClient.put<IBaseResponse>(url, body);
  },

  deleteNote(noteId: string) {
    const url = urlApiNotes.deleteNote(noteId);
    return axiosClient.delete<IBaseResponse>(url);
  },
};

export default notesApi;
